import { Breakpoint } from '@mui/system'

export const breakpoints: Record<Breakpoint, number> = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
}
